<template>
  <div :class="onModal ? '' : 'container-fluid'">
    <barra-crud
      :botaoNovo="true"
      :onFiltrar="
        (txt) => {
          filtro = txt;
        }
      "
      :breadcrumb="false"
      :busca-aberta="true"
      :onNovo="() => openCliente(null)"
      :size-bt="isMobile ? 'md' : 'lg'"
      :show-title="!onModal"
      :nome-customizado="'Cliente'"
      :class="isMobile ? 'mobile-barra' : ''"
    />
    <div v-if="!onModal && selecionados.length > 0" class="d-flex align-items-center justify-content-between p-2 mb-2 bg-light border rounded">
      <span>
        <strong>{{ selecionados.length }}</strong> cliente(s) selecionado(s)
      </span>
      <div>
        <b-btn
          size="sm"
          variant="outline-secondary"
          class="mr-2"
          @click="limparSelecao"
        >Limpar</b-btn>
        <b-btn
          size="sm"
          variant="warning"
          :disabled="selecionados.length < 2"
          @click="abrirUnificar"
        >
          <i class="fas fa-object-group" /> Unificar selecionados
        </b-btn>
      </div>
    </div>
    <div
      class="text-center p-5"
      v-if="loading"
    >
      <b-spinner
        large
        size="lg"
      /><br />
      carregando...
    </div>
    <div
      class="row"
      :class="{ 'no-gutters': onModal }"
      v-if="!loading"
    >
      <div
        class="col-12 text-left p-0"
        :class="onModal ? '' : (isMobile ? 'p-0' : 'p-lg-5')"
      >
        <b-table
          v-if="!isMobile"
          :responsive="onModal"
          :items="lista"
          :current-page="currentPage"
          :per-page="perPage"
          hover
          select-mode="single"
          ref="tbLista"
          selectable
          :bordered="false"
          :filter="filtro"
          stacked="sm"
          @row-selected="
            (its) =>
              its && its.length > 0
                ? openCliente(its[0].cod_cliente, onModal)
                : openCliente(null, true)
          "
          :fields="[
            { key: 'sel', label: '', class: onModal ? 'd-none' : 'text-center', thStyle: { width: '40px' } },
            { key: 'cod_cliente', label: '', searchable: true },
            { key: 'Nome', label: 'Nome', sortable: true, class: 'w-50' },
            { key: 'Telefone', label: 'Telefone', sortable: true },
            {
              key: 'saldo',
              label: 'Saldo',
              sortable: true,
              class: 'text-center ' + (onModal ? 'd-none' : ''),
            },
            { key: 'situacao', label: 'Situação' },
            {
              key: 'situacao_acesso',
              label: 'Acesso',
              class: onModal ? 'd-none' : '',
            },
            {
              key: 'opc',
              label: '',
              class: onModal ? '' : 'd-none',
            },
          ]"
        >
          <template #cell(sel)="row">
            <b-form-checkbox
              :checked="selecionados.includes(row.item.cod_cliente)"
              @change="toggleSelecionado(row.item.cod_cliente)"
              @click.native.stop
            />
          </template>
          <template #cell(cod_cliente)="row">
            <b-avatar
              size="lg"
              :src="
                !row.item.foto || row.item.foto.length <= 0
                  ? `https://ui-avatars.com/api/?name=${row.item.Nome}&size=128&background=777&color=fff`
                  : row.item.foto[0].fileURL
              "
            ></b-avatar>
          </template>
          <template #cell(saldo)="row">
            {{ row.item.saldo | currency }}
          </template>
          <template #cell(opc)="row">
            <div class="d-flex w-100 col-12">
              <b-btn
                size="sm"
                variant="success"
                block
                ref="btSel"
                @click="selectCliente(row.item)"
                v-if="onModal"
                >Selecionar</b-btn
              >

              <b-button
                size="sm"
                variant="primary"
                @click.stop="openCliente(row.item.cod_cliente, false)"
                >Editar</b-button
              >
            </div>
          </template>
        </b-table>

        <!-- Mobile Card View -->
        <div v-if="isMobile" class="cliente-cards">
          <div v-for="(item, index) in filteredItems" :key="index"
               class="cliente-card">
            <div class="card-header d-flex align-items-center">
              <b-form-checkbox
                v-if="!onModal"
                :checked="selecionados.includes(item.cod_cliente)"
                @change="toggleSelecionado(item.cod_cliente)"
                @click.native.stop
                class="mr-2"
              />
              <b-avatar
                size="md"
                :src="
                  !item.foto || item.foto.length <= 0
                    ? `https://ui-avatars.com/api/?name=${item.Nome}&size=128&background=777&color=fff`
                    : item.foto[0].fileURL
                "
              ></b-avatar>
              <div class="ml-2">
                <h5 class="mb-0">{{ item.Nome }}</h5>
                <small>{{ item.Telefone }}</small>
              </div>
            </div>
            <div class="card-body">
              <div class="d-flex justify-content-between" v-if="!onModal">
                <span>Saldo:</span>
                <span><strong>{{ item.saldo | currency }}</strong></span>
              </div>
              <div class="d-flex justify-content-between">
                <span>Situação:</span>
                <span><strong>{{ item.situacao }}</strong></span>
              </div>
              <div class="d-flex justify-content-between" v-if="!onModal">
                <span>Acesso:</span>
                <span><strong>{{ item.situacao_acesso }}</strong></span>
              </div>
            </div>
            <div class="card-footer d-flex justify-content-end">
              <b-btn
                size="sm"
                variant="success"
                @click.stop="selectCliente(item)"
                v-if="onModal"
                class="mr-2"
                >Selecionar</b-btn
              >
              <b-button
                size="sm"
                variant="primary"
                @click.stop="openCliente(item.cod_cliente, false)"
                >Editar</b-button
              >
            </div>
          </div>
        </div>

        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </div>
      <div
        v-if="editId && onModal"
        class="p-3 w-100"
      >
        <b-btn
          block
          size="lg"
          variant="success"
          ref="btSel"
          @click="selectCliente(null)"
          >SELECIONAR CLIENTE</b-btn
        >
      </div>
    </div>
    <b-modal
      id="modal-form-cliente"
      hide-footer
      :size="isMobile ? 'xl' : 'md'"
      :fullscreen="isMobile"
      :content-class="'prodModal' + (isMobile ? 'modal-full' : '')"
      :body-class="'insideModal p-0 pt-2' + (isMobile ? 'modal-full' : '')"
      no-fade
      no-footer
      :hide-header="isMobile"
      class="prodModal"
      :title="!editId ? 'Cadastrando Cliente' : 'Editando Cliente'"
      @hidden="closeForm"
    >
      <cliente-completo
        :id="editId"
        @close="closeForm"
        @closeAndOpen="closeFormSel"
      ></cliente-completo>
    </b-modal>

    <cliente-unificar-modal
      v-if="!onModal"
      :clientes="clientesSelecionados"
      @unificado="onUnificado"
    />

    <!-- Mobile Action Button -->
    <div v-if="isMobile && !onModal" class="mobile-fab">
      <b-button
        variant="primary"
        size="lg"
        class="rounded-circle"
        @click="openCliente(null)"
      >
        <i class="fas fa-plus"></i>
      </b-button>
    </div>
  </div>
</template>

<script>
import ClienteCompleto from "../../../components/clientes/ClienteCompleto.vue";
import ClienteUnificarModal from "../../../components/clientes/ClienteUnificarModal.vue";
import BarraCrud from "../../../components/common/BarraCrud.vue";
import ClientesLib from "../../../libs/ClientesLib";
export default {
  components: {
    BarraCrud,
    ClienteCompleto,
    ClienteUnificarModal,
  },
  props: {
    onModal: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.carregar();
    window.addEventListener('resize', this.checkMobile);
    this.checkMobile();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  data() {
    return {
      loading: false,
      lista: [],
      totalRows: 1,
      currentPage: 1,
      perPage: this.onModal ? 5 : 15,
      filtro: "",
      editId: null,
      isMobile: false,
      windowWidth: window.innerWidth,
      selecionados: [],
    };
  },
  watch: {
    editId(val) {
      if (val) {
        this.$refs.btSel.focus();
      }
    },
  },
  computed: {
    clientesSelecionados() {
      return this.lista.filter((c) => this.selecionados.includes(c.cod_cliente));
    },
    filteredItems() {
      if (!this.filtro) return this.lista.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
      
      return this.lista
        .filter(item => {
          const searchTerm = this.filtro.toLowerCase();
          return (
            (item.Nome && item.Nome.toLowerCase().includes(searchTerm)) ||
            (item.Telefone && item.Telefone.toLowerCase().includes(searchTerm)) ||
            (item.situacao && item.situacao.toLowerCase().includes(searchTerm))
          );
        })
        .slice(
          (this.currentPage - 1) * this.perPage,
          this.currentPage * this.perPage
        );
    }
  },
  methods: {
    toggleSelecionado(cod_cliente) {
      const idx = this.selecionados.indexOf(cod_cliente);
      if (idx >= 0) this.selecionados.splice(idx, 1);
      else this.selecionados.push(cod_cliente);
    },
    limparSelecao() {
      this.selecionados = [];
    },
    abrirUnificar() {
      if (this.selecionados.length < 2) return;
      this.$bvModal.show("modal-unificar-clientes");
    },
    onUnificado(data) {
      this.showToast("success", "Unificação concluída", 2500, "Destino: #" + data.cod_cliente_destino);
      this.selecionados = [];
      this.carregar();
    },
    checkMobile() {
      this.windowWidth = window.innerWidth;
      this.isMobile = window.innerWidth < 768;
      this.perPage = this.isMobile ? (this.onModal ? 3 : 10) : (this.onModal ? 5 : 15);
    },
    selectCliente(hasClient = null) {
      console.log("ok", hasClient);
      if (hasClient) {
        this.editId = hasClient.cod_cliente;
        this.$emit("selectCliente", hasClient.cod_cliente);
        this.closeForm();
      } else {
        this.$emit("selectCliente", this.editId);
        this.closeForm();
      }
    },
    async closeFormSel(idSel) {
      console.log("idSel===>", idSel, this.onModal);
      if (idSel && this.onModal) {
        // await this.openCliente(idSel);
        
        this.selectCliente({
          cod_cliente: idSel,
        });
        return;
      }
    },
    async closeForm() {
      this.$bvModal.hide("modal-form-cliente");
      if(this.$refs.tbLista && this.$refs.tbLista.clearSelected)
        this.$refs.tbLista.clearSelected();
      this.carregar();
    },
    openCliente(id, tab = false) {
      console.log("open cliente", id, tab);
      this.editId = id;
      if (this.onModal && id && tab) {
        this.editId = id;
        this.$emit("selectCliente", id);
      } else if (!tab) {
        this.$bvModal.show("modal-form-cliente");
      }
    },
    async carregar() {
      this.loading = true;

      try {
        let res = await ClientesLib.getAllClientes(null);
        console.log("res clientes", res);
        if (res && res.success) {
          this.lista = res.data;
          this.totalRows = this.lista.length;
          this.currentPage = 1;
        }
      } catch (error) {
        console.log("ERROR ON GET CLIENTES", error);
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.cliente-cards {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.0rem;
  padding-top: 1rem;
}

.cliente-card {
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background: white;
  transition: transform 0.2s ease;
  
  &:active {
    transform: scale(0.98);
  }
  
  .card-header {
    padding: 1rem;
    background-color: #f8f9fa;
    border-bottom: 1px solid #eee;
  }
  
  .card-body {
    padding: 1rem;
    
    .d-flex {
      margin-bottom: 0.5rem;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  
  .card-footer {
    padding: 0.75rem;
    background-color: #f8f9fa;
    border-top: 1px solid #eee;
  }
}

.mobile-fab {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 999;
  
  .btn {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    
    i {
      font-size: 1.5rem;
    }
  }
}

.mobile-barra {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
</style>
